import { Steps } from 'antd';
import { ButtonType, HtmlType, Space } from 'farmhub-ui-core';
import styled from 'styled-components';

import { CButton } from 'components';
import { GlobalStyle } from 'styled';

import { ContentMobileStep, MobileWrapper, TextStep } from '../styles';

export interface StoreCreatePageContentMobileProps {
  handleSubmitStep: (e: number) => void;
  handleNextStep: () => any;
  ListStep: any[];
  isSubmitting: boolean;
  currentTab: number;
  handleChangeCurrentStep: (e: number) => void;
}

const { Step } = Steps;

const StoreCreatePageContentMobile = ({
  handleSubmitStep,
  handleNextStep,
  ListStep,
  isSubmitting,
  currentTab,
  handleChangeCurrentStep,
}: StoreCreatePageContentMobileProps): JSX.Element => (
  <MobileWrapper>
    <Steps
      current={currentTab}
      labelPlacement="vertical"
      style={{ width: 'fit-content' }}
    >
      {ListStep.length === 4 ? (
        <>
          <CStep
            style={{ cursor: 'pointer' }}
            title="Thông tin"
            onClick={() => handleChangeCurrentStep(0)}
          />
          <CStep
            style={{ cursor: 'pointer' }}
            title="LK đối tác"
            onClick={() => handleSubmitStep(1)}
          />
          <CStep
            style={{ cursor: 'pointer' }}
            title="Sản phẩm"
            onClick={() => handleSubmitStep(2)}
          />

          <CStep
            style={{ cursor: 'pointer' }}
            title="Chính sách giá"
            onClick={() => handleSubmitStep(3)}
          />
        </>
      ) : (
        <>
          <Step
            style={{ cursor: 'pointer' }}
            title="Thông tin"
            onClick={() => handleChangeCurrentStep(0)}
          />
          <Step
            style={{ cursor: 'pointer' }}
            title="Liên kết đối tác"
            onClick={() => handleSubmitStep(1)}
          />
          <Step
            style={{ cursor: 'pointer' }}
            title="Sản phẩm"
            onClick={() => handleSubmitStep(2)}
          />
        </>
      )}
    </Steps>
    <Space height={18} />
    <ContentMobileStep>
      {ListStep[currentTab]}
      <CButton
        htmlType={HtmlType.Submit}
        loading={isSubmitting}
        type={ButtonType.Primary}
        width="100%"
        onClick={handleNextStep}
      >
        Xác nhận
      </CButton>
      <div id="recaptcha-container" />
    </ContentMobileStep>
    <GlobalStyle />
  </MobileWrapper>
);

export default StoreCreatePageContentMobile;

const CStep = styled(Step)`
  .ant-steps-item-container {
    width: fit-content;
    .ant-steps-item-icon {
      margin: 0 16px 0 36px !important;
    }
    .ant-steps-item-tail {
      width: 100%;
      left: -10px;
    }
    .ant-steps-item-content {
      width: fit-content;
      margin: 8px 12px 0;
      .ant-steps-item-title {
        white-space: nowrap;
      }
    }
  }
`;
